<template>
  <!-- 登录弹窗 -->
  <div class="log-modal">
    <div class="content_box" v-if="showIndex==1">
      <!-- <p class="close cursor" @click="goBack()"><img src="@/assets/close.png" alt="" /></p> -->
      <p class="tips_title">登录</p>
      <el-form
        class="form_box"
        ref="form"
        :model="logInfo"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="输入账号">
          <el-input v-model="logInfo.phone" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="输入密码">
          <el-input v-model="logInfo.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <p class="tips cursor" @click="showIndex=3">忘记密码?</p>
      <div class="login_btn cursor" @click="logBtn()">登录</div>
      <div class="go_reign cursor" @click="showIndex=2">没有账号？去注册></div>
    </div>
    <div class="content_box" v-if="showIndex==2">
      <!-- <p class="close  cursor" @click="goBack()"><img src="@/assets/close.png" alt="" /></p> -->
      <p class="tips_title">注册</p>
      <el-form
        class="form_box"
        ref="form"
        :model="regData"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="姓名">
          <el-input v-model="regData.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item label="单位">
          <el-select filterable  v-model="regData.company_id" placeholder="选择所在单位">
              <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="输入手机号">
          <el-input v-model="regData.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="输入密码">
          <el-input v-model="regData.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="再次输入密码">
          <el-input v-model="regData.confirm_password" type="password" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <el-form-item label="验证码验证">
          <div class="code_cont flex">
                <el-input
                v-model="regData.code"
                placeholder="请输入验证码"
              ></el-input>
              <p class="code_text cursor" @click="timer?'': getCode()">{{getCodeBtnText}}</p>
              </div>
        </el-form-item>
      </el-form>
      <div class="login_btn cursor" @click="regBtn()">注册</div>
      <div class="go_reign cursor" @click="showIndex=1">已有账号？去登录></div>
    </div>
    <div class="content_box" v-if="showIndex==3">
      <!-- <p class="close  cursor" @click="goBack()"><img src="@/assets/close.png" alt="" /></p> -->
      <p class="tips_title">忘记密码</p>
      <el-form
        class="form_box"
        ref="form"
        :model="regData"
        label-width="80px"
        label-position="top"
      >
        <el-form-item label="输入手机号">
          <el-input v-model="regData.phone"></el-input>
        </el-form-item>
        <el-form-item label="输入新密码">
          <el-input v-model="regData.new_password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="再次输入密码">
          <el-input v-model="regData.confirm_password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="验证码验证">
          <div class="code_cont flex">
                <el-input
                v-model="regData.code"
                placeholder="请输入验证码"
              ></el-input>
              <p class="code_text cursor" @click="timer?'': getCode()">{{getCodeBtnText}}</p>
              </div>
        </el-form-item>
      </el-form>
      <div class="login_btn cursor" @click="changePass()">确认修改</div>
      <div class="go_reign cursor" @click="showIndex=1">已有账号？去登录></div>
    </div>
    <!-- 注册成功 -->
    <div class="content_box content_box4" v-if="showIndex==4">
      <!-- <p class="close  cursor" @click="goBack()"><img src="@/assets/close.png" alt="" /></p> -->
      <p class="tips_title">恭喜注册成功</p>
      <p class="tips_text">您已成功注册，请赶快登录吧</p>

      
      <div class="login_btn cursor" @click="showIndex=1">去登录</div>
    </div>
    <!-- 密码修改成功 -->
    <div class="content_box content_box4" v-if="showIndex==5">
      <!-- <p class="close  cursor" @click="goBack()"><img src="@/assets/close.png" alt="" /></p> -->
      <p class="tips_title">修改成功</p>
      <p class="tips_text">您的密码已修改成功，请重新登录</p>
      
      <div class="login_btn cursor" @click="showIndex=1">去登录</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { ApiUrl } from "@/utils/util";

export default {
  name: "Bottom",
  data() {
    return {
      logoState: true,
      loginType: 1, //1、个人登录，2、企业登录
      agree: true,
      showPass: false,
      avoidTheLogin: "",
      logInfo: {
        //登录信息
        phone: "", //手机号
        password: "", //密码
      },
      regData: {
        phone: "",
        code: "",
      },
      phoneErr: "", //手机号错误提示
      passErr: "", //登录报错提示
      shenHeState: false,
      siteInfo: "", //网站信息
      getCodeBtnText: "获取验证码",
      timer: "", //倒计时
    };
  },
  props: {
    showIndex: {
      type: Number,
      default: 1,
    },
  },
  mounted() {
    this.siteInfo = JSON.parse(localStorage.getItem("siteInfo"));
  },
  methods: {
    ...mapMutations(["CloseLoginModal", "ShowTipModal"]), //登录弹窗
    //登录
    logBtn() {
      if (this.loginType == 1) {
        if (this.logInfo.phone == "") {
          this.phoneErr = "请填写手机号";
          return;
        } else {
          let reg = /^0?1[3-9][0-9]\d{8}$/;

          if (!reg.test(this.logInfo.phone)) {
            this.phoneErr = "请填写正确的手机号";
            return;
          } else {
            this.phoneErr = "";
          }
        }

        this.$axios.post(`/study/login/login`, this.logInfo).then((res) => {
          console.log(res,'rse')
          if (res.code == 1) {
            localStorage.setItem("auth", JSON.stringify(res.data.token));
            localStorage.setItem("userData", JSON.stringify(res.data.phone));
            localStorage.setItem("user_avater", JSON.stringify(res.data.image));
            // location.reload();
            this.$router.go(-1)
              
          } else {
            this.$message.error(res.msg)  
          
          }
        });
      } else {
        this.$axios.post(`/v1/login/loginCode`, this.regData).then((els) => {
          if (els.code == 0) {
            //this.logModal = false;
            this.userInfo = els.data.user;
            localStorage.setItem("auth", JSON.stringify(els.data.auth));
            localStorage.setItem("user", JSON.stringify(els.data.user));
            localStorage.setItem("userInfo", JSON.stringify(els.data.user));

            this.$axios
              .post(`/v1/px/loginRecord`, {}, { useLog: true })
              .then(() => {
                //登录记录
                if (
                  this.$route.name == "Registered" ||
                  this.$route.name == "WelcomeRegistered"
                ) {
                  this.CloseLoginModal();
                  this.$router.push("/index");
                } else {
                  this.$router.go(0); //刷新页面
                }
              });
          } else if (els.code == 2 || els.code == 3) {
            this.shenHeState = true;
          } else {
            this.ShowTipModal({
              text: els.msg, //提示弹窗内容
            });
          }
        });
      }
    },

   

    // 获取验证码
    getCode() {
      console.log('ddk')
      if (this.regData.phone) {
        let url = "";
        if (this.loginType == 2) {
          url = `/v1/login/sendSmsCode`;
        }
        this.$axios
          .post(`/study/login/sendSms`, {
            phone: this.regData.phone,
          })
          .then((res) => {
            this.codeErr = res.msg;

            if (res.code == 1) {
              let time = 60;

              this.getCodeBtnText = time + "秒后再获取";
              this.timer = setInterval(() => {
                time--;
                if (time == 0) {
                  this.getCodeBtnText = "获取验证码";
                  clearInterval(this.timer);
                  this.timer = "";
                } else {
                  this.getCodeBtnText = time + "秒后再获取";
                }
              }, 1000);
            }
          });
      } else {
        this.$message.error('请输入手机号')
      }
    },
    //注册按钮
    regBtn() {
      this.$axios.post(`/study/login/register`, this.regData).then((res) => {
        if(res.code==1){
          this.showIndex = 4;
          // this.$message.success('注册成功')
          // this.CloseLoginModal()
        }else{
          this.$message.error(res.msg)
        }
      })
      // this.CloseLoginModal();
      // this.$router.push("/registered");
    },

    // 修改密码
    changePass(){
      this.$axios.post(`/study/login/resetPassword`, this.regData).then((res) => {
        if(res.code==1){
          // this.$message.success('注册成功')
          this.showIndex = 5;
          // this.CloseLoginModal()
        }else{
          this.$message.error(res.msg)
        }
      })
    },

    //忘记密码
    forgotPass() {
      this.CloseLoginModal();
      this.$router.push("/changePassword");
    },
    // goBack() {
    //   this.CloseLoginModal();
    //   this.$router.push('/')
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.log-modal {
  width: 100%;
  height: 100%;
  background: #fff;
  min-height: calc(100vh - 80px);
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0px;
  z-index: 99;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   position: fixed;
//   top: 0;
//   left: 0;
//   background-color: rgba(0, 0, 0, 0.6);
//   z-index: 99;
  .content_box {
    margin: 52px 24px 0;
    border-radius: 5px 5px 5px 5px;
    p.close {
      display: flex;
      justify-content: flex-end;
      img {
        margin-right: -26px;
      }
    }
    p.tips_title {
      font-size: 26px;
      font-weight: 800;
      color: #333333;
      text-align: center;
    }
    .form_box {
      box-sizing: border-box;
      margin-top: 10px;
    }
    p.tips {
      font-size: 14px;
      color: #0080FF;
      text-align: right;
    }
    div.login_btn {
    //   width: 293px;
      height: 50px;
      background: #0080ff;
      border-radius: 8px 8px 8px 8px;
      text-align: center;
      line-height: 50px;
      color: #fff;
      font-size: 20px;
      margin: 20px 0;
      border-radius: 50px;
    }
    .go_reign {
      text-align: center;
      margin-top: 14px;
      text-decoration-line: underline;
      font-size: 16px;
      color: #0080ff;
    }
    .code_cont{
      border: 1px solid #DCDFE6;
      box-sizing: border-box;
      padding: 0 10px 0 0;
      border-radius: 50px;
      ::v-deep .el-input{
        flex: 1;
      }
      ::v-deep .el-input__inner{
        border: none;
      }
      p.code_text{
        margin-left: 10px;
        // width: 160px;
        padding: 0 15px;
        height: 31px;
        background: #ECF5FF;
        border-radius: 5px 5px 5px 5px;
        text-align: center;
        line-height: 31px;
        font-size: 14px;
        color: #666;
      }
    }
  }
  .content_box4{
    min-height: 220px;
    p{
      text-align: center;
    }
    p.tips_text{
      color: #999;
      margin-top: 10px;
      
    }
  }
}
::v-deep .el-form--label-top .el-form-item__label {
  padding-bottom: 0;
}
::v-deep .el-input__inner{
    border-radius: 50px;
}
::v-deep .el-form-item{
   margin-bottom: 12px;
}
</style>
